import React from 'react';
import styles from './ReportCardHeader.module.scss';
import { ReportCardHeaderActions } from './ReportCardHeaderActions/ReportCardHeaderActions';
import { SFText } from 'sfui';

export interface ReportCardHeaderProps {
  className?: string;
  incidentNumber: string;
  caseNumber?: string | undefined;
  onViewHistory: () => void;
  onScanQrCode: () => void;
  onSeeFullReport: () => void;
}

export const ReportCardHeader = ({
  className = '',
  incidentNumber,
  caseNumber,
  onViewHistory,
  onScanQrCode,
  onSeeFullReport
}: ReportCardHeaderProps): React.ReactElement<ReportCardHeaderProps> => {
  return (
    <div className={`${styles.reportCardHeader} ${className}`}>
      {caseNumber && (
        <div className={styles.incidentNumber}>
          <SFText type="component-messages" sfColor="neutral">
            CAD / CASE NUMBER
          </SFText>
          <SFText type="component-title">{caseNumber}</SFText>
        </div>
      )}

      {!caseNumber && (
        <div className={styles.incidentNumber}>
          <SFText type="component-messages" sfColor="neutral">
            INCIDENT NUMBER
          </SFText>
          <SFText type="component-title">{incidentNumber}</SFText>
        </div>
      )}

      <ReportCardHeaderActions
        onViewHistory={onViewHistory}
        onScanQrCode={onScanQrCode}
        onSeeFullReport={onSeeFullReport}
      />
    </div>
  );
};
